let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dfLQO")).then(() => parcelRequire('3I0V3'));